import React from 'react';
import { Heart, Film, Users, Clock } from 'lucide-react';

const reasons = [
  {
    icon: <Film className="w-7 h-7" />,
    title: "You'll actually want to watch it back.",
    description: "Not a boring, overly long edit. A cinematic film that makes you feel everything all over again. Every single time you press play.",
  },
  {
    icon: <Heart className="w-7 h-7" />,
    title: "Shot by people who love weddings, not just cameras.",
    description: "We've been part of over 900 love stories. We know the moments that matter. We know where to be. You'll forget we're even there.",
  },
  {
    icon: <Users className="w-7 h-7" />,
    title: "Your guests will talk about it for years.",
    description: "\"I cried watching your video.\" That's the text you'll get. From your mum. Your bridesmaid. Your partner. Maybe even your nan.",
  },
  {
    icon: <Clock className="w-7 h-7" />,
    title: "This day only happens once. Don't leave it to chance.",
    description: "Your flowers will wilt. Your cake will be eaten. But your wedding film? That's the one thing that lasts forever. We take that seriously.",
  },
];

const WhyWVE = () => {
  return (
    <section data-testid="why-wve-section" className="py-24" style={{ backgroundColor: '#FAF8F5' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="text-center mb-16">
          <p className="text-gold text-sm font-semibold uppercase tracking-widest mb-4">
            Why couples choose us
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl text-gray-900 leading-tight">
            The biggest regret of couples<br />who don't book a videographer?
          </h2>
          <p className="text-gray-500 text-lg mt-4">Not booking a videographer.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reasons.map((reason, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 text-center group"
            >
              <div className="w-14 h-14 rounded-xl bg-gray-900 text-gold flex items-center justify-center mb-5 mx-auto group-hover:bg-gold group-hover:text-white transition-colors duration-300">
                {reason.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3 leading-snug">
                {reason.title}
              </h3>
              <p className="text-gray-500 leading-relaxed text-sm">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyWVE;
